module.exports = __webpack_public_path__ + "static/media/extraImage2.f16a8c3e.png";